import React, { forwardRef } from 'react';
import BaseButton from './BaseButton';

const AddButton = forwardRef(({ title = 'Add', ...props }, ref) => (
  <BaseButton
    ref={ref}
    id='add-button'
    icon='add'
    tooltip={title}
    themeColor='light'
    {...props}
  />
));

export default AddButton;
